/*
 * Fig & Bloom - same-day cutoff, as shown to the customer.
 *
 * Enforcement stays on the stored cutoffTime (13:15 in Melbourne, Sydney and
 * Brisbane). This file only decides the clock time in the "Order before …"
 * banner. It does not decide whether Today is offered.
 *
 *   displayCutoffTime, when it is a valid H:MM / HH:MM and no later than
 *   cutoffTime
 *   otherwise 13:00 when cutoffTime is 13:15
 *   otherwise cutoffTime, unchanged
 *   no cutoffTime → null, and the banner is left as it is today
 *
 * The label is hand-formatted in the same style as the pickup slots
 * (assets/fb-pickup-time.js formatHour): "1:00 pm", lowercase am/pm, minutes
 * always shown. Not toLocaleTimeString — that yields "PM" and a narrow space.
 *
 * Loaded immediately before assets/delivery-suburb-popup.js (see the stub in
 * snippets/delivery-suburb-popup.liquid). Pure: no DOM, no clock.
 */
(function (root) {
  'use strict';

  var ONE_FIFTEEN = 13 * 60 + 15;
  var ONE_OCLOCK = 13 * 60;

  // "9:00" / "09:00" / "13:15" → minutes since midnight, or null.
  function parseClock(value) {
    if (typeof value !== 'string') return null;
    var match = /^(\d{1,2}):(\d{2})$/.exec(value.trim());
    if (!match) return null;
    var hour = parseInt(match[1], 10);
    var minute = parseInt(match[2], 10);
    if (hour > 23 || minute > 59) return null;
    return hour * 60 + minute;
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Minutes since midnight to show, or null when there is no cutoff.
  function displayMinutes(settings) {
    if (!settings) return null;
    var cutoff = parseClock(settings.cutoffTime);
    if (cutoff == null) return null;
    var explicit = parseClock(settings.displayCutoffTime);
    if (explicit != null && explicit <= cutoff) return explicit;
    if (cutoff === ONE_FIFTEEN) return ONE_OCLOCK;
    return cutoff;
  }

  // "13:00", or null when there is nothing to show.
  function time(settings) {
    var minutes = displayMinutes(settings);
    if (minutes == null) return null;
    return pad(Math.floor(minutes / 60)) + ':' + pad(minutes % 60);
  }

  // 13*60 → "1:00 pm", 9*60+5 → "9:05 am", 0 → "12:00 am", 12*60 → "12:00 pm".
  function label(settings) {
    var minutes = displayMinutes(settings);
    if (minutes == null) return null;
    var hour = Math.floor(minutes / 60);
    var minute = minutes % 60;
    var suffix = hour >= 12 ? 'pm' : 'am';
    var h12 = hour % 12 === 0 ? 12 : hour % 12;
    return h12 + ':' + pad(minute) + ' ' + suffix;
  }

  var api = { time: time, label: label };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.fbCutoffDisplay = api;
})(typeof window !== 'undefined' ? window : globalThis);
